import { collection } from 'firebase/firestore'
import { db } from '../Firebase/config'

const portfolioRef = collection(db,'portfolio')
const skillRef = collection(db,'skills')

export {portfolioRef, skillRef}